import { http } from '../http';

export type DownloadFiles = {
  dateCreated: string;
  description: string;
  fileId: string;
  dateAccessed?: string;
};

const getDownloadFile = async (reference: string) => {
  const headers = { responseType: 'arraybuffer' };
  const response = await http.get(`/api/v1/downloads/${reference}`, { headers });

  return response;
};

const getClientDataFiles = async (): Promise<DownloadFiles[]> => {
  const response = await http.get<DownloadFiles[]>('/api/v1/downloads');
  return response.data;
};

const getLoandataPdf = async (commercialLabel: string, loanNumber: number) => {
  const response = await http({
    method: 'get',
    url: `/api/v1/clients/${commercialLabel}/${loanNumber}/loandata/pdf`,
    responseType: 'arraybuffer',
  });

  return response;
};

export { getClientDataFiles, getDownloadFile, getLoandataPdf };
